// @flow
import dayjs from "dayjs";
import React, { useMemo } from 'react';
import SkeletonLoaderWrapper from "../../../../components/general/skeletonLoaderWrapper/skeletonLoaderWrapper";
import { formatDate } from "../../../../helpers/date";
import Form from "./form";

type Props = {};

const SelectExhibitions = (props: Props) => {
		const { coorganizationId, exhibitions, exhibitionsLoading, onSuccess, coorganizationExhibitions, mainExhibitionId, descriptionEl, descriptionEn } = props
	const parseExhibitions = useMemo(() => (
		exhibitions?.filter(i => (coorganizationExhibitions?.includes(i.id) || dayjs(i.dateFrom).isAfter(dayjs())))?.map(i => ({
			id: i.id,
			coorganizationId: i.coorganizationId,
			description: `${i.title} ${formatDate(i.dateFrom, formatDate.formatTypes.DATE_ONLY)} - ${formatDate(i.dateTo, formatDate.formatTypes.DATE_ONLY)}`,
			dateFrom: i.dateFrom
		}))
	), [coorganizationExhibitions, exhibitions])

	const parseCoorganizationExhibitions = useMemo(() => (
		exhibitions?.filter(i => (coorganizationExhibitions?.includes(i.id)))?.map(i => ({
			id: i.id,
			coorganizationId: i.coorganizationId,
			description: `${i.title} ${formatDate(i.dateFrom, formatDate.formatTypes.DATE_ONLY)} - ${formatDate(i.dateTo, formatDate.formatTypes.DATE_ONLY)}`,
			dateFrom: i.dateFrom
		}))
	), [coorganizationExhibitions, exhibitions])
	
		return (
			<SkeletonLoaderWrapper loading={exhibitionsLoading}>
				<Form
					exhibitions={parseExhibitions}
					coorganizationId={coorganizationId}
					onSuccess={onSuccess}
					coorganizationExhibitions={parseCoorganizationExhibitions}
					mainExhibitionId={mainExhibitionId}
					descriptionEn={descriptionEn}
					descriptionEl={descriptionEl}
				/>
			</SkeletonLoaderWrapper>
		);
	}
;

export default SelectExhibitions